import script from "./TheGlobal.js?vue&type=script&lang=js"
export * from "./TheGlobal.js?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__